import { List } from '@farol-ds/react'

import { SubjectProps } from '../../types'
import { SubjectItem } from '../subject-item'
import styles from '../subjects.module.scss'

export type SubjectsListProps = {
  subjects: SubjectProps[]
}

export function SubjectsList(props: SubjectsListProps) {
  const { subjects } = props

  return (
    <List className={styles.list}>
      {subjects.map((subject, index) => (
        <SubjectItem subject={subject?.name} key={index} />
      ))}
    </List>
  )
}
